/**
 * First-party cookie storage for GDPR cookie consent.
 * Stores consent in a cookie (not localStorage) for semantic consistency
 * with cookie consent best practices.
 *
 * Cookie attributes: SameSite=Lax, Secure (HTTPS), path=/, 1 year expiry.
 */
const CONSENT_COOKIE_NAME = 'franca_cookie_consent'
const MAX_AGE_ONE_YEAR = 365 * 24 * 60 * 60 // seconds

const getCookieString = () => {
  if (typeof document === 'undefined') return ''
  return document.cookie
}

export const getConsentCookie = () => {
  try {
    const cookies = getCookieString().split(';')
    for (const c of cookies) {
      const [name, ...rest] = c.trim().split('=')
      if (name === CONSENT_COOKIE_NAME && rest.length) {
        const value = rest.join('=').trim()
        return decodeURIComponent(value)
      }
    }
  } catch (e) {
    console.warn('Could not read consent cookie:', e)
  }
  return null
}

export const setConsentCookie = (value) => {
  if (typeof document === 'undefined') return
  try {
    const encoded = encodeURIComponent(value)
    const isSecure = typeof window !== 'undefined' && window.location?.protocol === 'https:'
    const parts = [
      `${CONSENT_COOKIE_NAME}=${encoded}`,
      'path=/',
      `max-age=${MAX_AGE_ONE_YEAR}`,
      'SameSite=Lax',
      ...(isSecure ? ['Secure'] : []),
    ]
    document.cookie = parts.join('; ')
  } catch (e) {
    console.warn('Could not set consent cookie:', e)
  }
}

export const clearConsentCookie = () => {
  try {
    if (typeof document !== 'undefined') {
      document.cookie = `${CONSENT_COOKIE_NAME}=; path=/; max-age=0`
    }
  } catch (e) {
    console.warn('Could not clear consent cookie:', e)
  }
}
